<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  BILLING_PERIOD_LABEL_KEYS,
  STANDARD_BILLING_PERIOD_DAYS,
} from 'dashboard/constants/billingPeriods';

const props = defineProps({
  availableDays: {
    type: Array,
    default: () => [],
  },
});

const selectedDays = defineModel({
  type: Number,
  default: 30,
});

const { t } = useI18n();

const periodOptions = computed(() =>
  STANDARD_BILLING_PERIOD_DAYS.map(days => ({
    days,
    label: t(
      `GENERAL_SETTINGS.BILLING_SELECT_PLAN_PAGE.${BILLING_PERIOD_LABEL_KEYS[days]}`
    ),
    available: props.availableDays.includes(days),
  }))
);

const selectDays = days => {
  if (!props.availableDays.includes(days)) return;
  selectedDays.value = days;
};
</script>

<template>
  <div
    role="group"
    class="inline-flex max-w-full flex-wrap gap-1 rounded-lg border border-n-weak bg-n-slate-2 p-1"
    :aria-label="t('GENERAL_SETTINGS.BILLING_SELECT_PLAN_PAGE.CYCLE_ARIA')"
  >
    <button
      v-for="option in periodOptions"
      :key="option.days"
      type="button"
      class="rounded-md px-3 py-1.5 text-sm font-medium transition-colors duration-200"
      :class="[
        selectedDays === option.days && option.available
          ? 'bg-n-surface-1 text-n-slate-12 shadow-sm'
          : 'text-n-slate-11 hover:text-n-slate-12',
        !option.available && 'cursor-not-allowed opacity-50',
      ]"
      :disabled="!option.available"
      :aria-pressed="selectedDays === option.days"
      @click="selectDays(option.days)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
